export const TYPES = {
  SELECT_ALL_SERVICES: "service/SELECT_ALL_SERVICES",
};
